import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';

export const getFeatureTrialDuration = (featureEnum: Feature) => {
  switch (featureEnum) {
    default:
      return 30;
  }
};
